import { config, authHeader, } from '../helpers'
import { handleHttpResponse } from '../helpers'

export const Auth0Service = {
    checkThatAuth0UserExists,
    resendEmailValidation
}

// retrieves the labels of the given page id
function checkThatAuth0UserExists({ email, auth0ID }) {
    const requestOptions = {
      method: "POST",
      headers: { "Content-Type": "application/json", ...authHeader() },
      body: JSON.stringify({ "email": email, "auth0ID": auth0ID })
    }
  
    return fetch(`${config.apiUrl}/auth0/check-user`, requestOptions)
      .then(handleHttpResponse)
      .then(user => {
        return user
    })
}

function resendEmailValidation({ auth0ID }) {
  const requestOptions = {
    method: "POST",
    headers: { "Content-Type": "application/json", ...authHeader() },
    body: JSON.stringify({ "auth0ID": auth0ID })
  }

  return fetch(`${config.apiUrl}/auth0/resend-email-validation`, requestOptions)
    .then(handleHttpResponse)
    .then(() => {
      return
  })
}